import { decode } from 'html-entities';
import striptags from 'striptags';

const stripHtml = (str: string) => striptags(decode(str));

export default stripHtml;
